(function() {
	"use strict"

	angular.module("ATMGApi", [])

})()


// WEBPACK FOOTER //
// ./src/app/modules/ATMGApi/ATMGApi.js